import React from 'react';
import { PlayCircleIcon } from 'lucide-react';
export function VideoSection() {
  return <section className="w-full bg-[#0a0a0a] py-8 md:py-16 px-4" data-id="element-282">
      <div className="max-w-3xl mx-auto" data-id="element-283">
        <div className="bg-[#111] p-6 md:p-12 rounded-lg border-l-8 border-[#c41e3a] shadow-lg" data-id="element-284">
          <div className="flex justify-center mb-5" data-id="element-285">
            <PlayCircleIcon className="w-12 h-12 md:w-16 md:h-16 text-[#c41e3a]" aria-hidden="true" data-id="element-286" />
          </div>
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase text-center mb-2" data-id="element-287">
            Incluido en la formación
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-4 text-center leading-tight" data-id="element-288">
            Material <span className="text-[#c41e3a]" data-id="element-289">audiovisual</span> de
            apoyo incluido
          </h2>
          <div className="w-12 h-0.5 bg-[#c41e3a] mx-auto mb-4" data-id="element-290"></div>
          <p className="text-sm md:text-lg text-gray-300 leading-relaxed text-center mb-4" data-id="element-291">
            Además de los ebooks, la formación incluye{' '}
            <span className="text-white font-bold" data-id="element-292">videos complementarios</span>{' '}
            para reforzar técnicas y ver su aplicación práctica en tiempo real.
          </p>
          <p className="text-sm md:text-base text-gray-200 font-black text-center mb-5" data-id="element-293">
            Los videos no reemplazan el método escrito: lo acompañan y te
            muestran las técnicas en acción.
          </p>
          <div className="bg-[#0a0a0a] border border-[#c41e3a]/40 rounded-lg p-4 md:p-6" data-id="element-294">
            <p className="text-gray-300 text-sm md:text-base text-center leading-relaxed" data-id="element-295">
              📚{' '}
              <span className="font-bold text-white" data-id="element-296">
                Ebooks para estudiar y consultar
              </span>{' '}
              + 🎥{' '}
              <span className="font-bold text-white" data-id="element-297">
                Videos para ver técnicas aplicadas
              </span>{' '}
              = Formación completa
            </p>
          </div>
        </div>
      </div>
    </section>;
}